module.exports = new Promise((resolve) => {
    if (!window.__fileMap) {
        window.__fileMap = {};
    }
    // we need to let webpack to be able to resolve and wire the modules to the existing already loaded micro front end
    if (window.__fileMap['BoTableManagementApp']) {
        resolve({
            get: (request) => {
                // since the app is already loaded previous and our module list are synced, we do not need fallback here
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return window['BoTableManagementApp']?.get(request);
            },
            init: (arg) => {
                try {
                    return window['BoTableManagementApp'].init(arg);
                }
                catch (e) { }
            },
        });
    }
    const script = document.createElement('script');
    const fallback = JSON.parse('{"./routes/table-management":{"appName":"BoLegacyApp","exposesKey":"./pages/NotFound"}}');
    function scriptExists(appName) {
        return (window['BoTableManagementApp'] !== undefined ||
            document.querySelectorAll(`script[src*="${appName}"]`).length > 0);
    }
    const appName = 'BoTableManagementApp';
    if (scriptExists(appName)) {
        // Used to override remote entry from local remote entry
        script.src = `/remote-entry-${appName}.js`;
    }
    else {
        script.src = 'https://backoffice.mokapos.com/table-management-micro-apps/remote-entry-BoTableManagementApp.js';
    }
    script.onload = () => {
        const proxy = {
            get: (request) => {
                if (!!window['BoTableManagementApp']) {
                    return window['BoTableManagementApp'].get(request);
                }
                else {
                    // Handle CORB issue
                    // see https://stackoverflow.com/questions/65080522/can-i-programmatically-detect-whether-a-corb-error-occurred
                    const _appName = fallback[request]?.appName || 'BoTableManagementApp';
                    const _request = fallback[request]?.exposesKey || request;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    return window?.[_appName]?.get(_request);
                }
            },
            init: (arg) => {
                try {
                    return window['BoTableManagementApp'].init(arg);
                }
                catch (e) { }
            },
        };
        window.__fileMap['BoTableManagementApp'] = true;
        resolve(proxy);
        document.head.removeChild(script);
    };
    script.onerror = () => {
        const proxy = {
            get: (request) => {
                const _appName = fallback[request]?.appName || 'BoTableManagementApp';
                const _request = fallback[request]?.exposesKey || request;
                // TODO: handle with recursive fallback
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return window[_appName]?.get(_request);
            },
            init: (arg) => {
                try {
                    return window['BoTableManagementApp'].init(arg);
                }
                catch (e) { }
            },
        };
        window.__fileMap['BoTableManagementApp'] = true;
        resolve(proxy);
        document.head.removeChild(script);
    };
    document.head.appendChild(script);
});